import { useMemo } from 'react';
import { useBooking } from '../state';
import { useLanguage } from '@core/i18n';

interface EventTranslation {
  title: string;
  description: string;
  slug: string;
  dates: string[];
  serviceTypes: string[];
}

export function useEventTranslation(): EventTranslation | null {
  const { specialEvent } = useBooking();
  const { currentLanguage } = useLanguage();

  return useMemo(() => {
    if (!specialEvent) return null;

    const t = specialEvent.translations?.[currentLanguage];

    return {
      title: t?.title || specialEvent.title,
      description: t?.description || specialEvent.description,
      slug: specialEvent.slug,
      dates: specialEvent.dates,
      serviceTypes: specialEvent.serviceTypes,
    };
  }, [specialEvent, currentLanguage]);
}
